"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useRef } from "react";
import DirectMessagesList from "../direct-messages/DirectMessagesList";
import { useLayout } from "../my-stream/layout/LayoutContext";
const BrainMobileMessages: React.FC = () => {
  const $ = _c(3);
  const {
    mobileWavesViewStyle
  } = useLayout();
  const scrollContainerRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DirectMessagesList scrollContainerRef={scrollContainerRef} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== mobileWavesViewStyle) {
    t1 = <div ref={scrollContainerRef} className="tw-overflow-y-auto tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800 desktop-hover:hover:tw-scrollbar-thumb-iron-300 tw-space-y-4 tw-px-2 sm:tw-px-4 md:tw-px-6 tw-pt-2" style={mobileWavesViewStyle}>{t0}</div>;
    $[1] = mobileWavesViewStyle;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default BrainMobileMessages;